import { Zoom } from '@material-ui/core'
import './DoubleBar.css'

const DoubleBar = ({
  homeCount,
  homeColour,
  awayCount,
  awayColour,
  total,
  units,
  title
}) => {
  const noData = homeCount === 0 && awayCount === 0

  return (
    <div className="outerContainer">
      <p className="text">{title}</p>
      <Zoom in={true}>
        <div className="barContainer">
          <div
            className="leftBar"
            style={{
              width: `${noData ? 50 : (homeCount / total) * 100}%`,
              backgroundColor: homeColour
            }}
          >
            <b className="number">
              {homeCount}
              {units}
            </b>
          </div>
          <div className="divider" />
          <div
            className="rightBar"
            style={{
              height: '20px',
              width: `${noData ? 50 : (awayCount / total) * 100}%`,
              backgroundColor: awayColour
            }}
          >
            <b className="number">
              {awayCount}
              {units}
            </b>
          </div>
        </div>
      </Zoom>
    </div>
  )
}

export default DoubleBar
